import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../../components/tables/tableContext/TableContext";
import { ActiveTransportsDataInterface } from "../../../../../redux/interfaces/transport.interface";
import { getDateAndTime } from "../../../../../utils/dateAndTime";

const routesTypes = [
  {
    value: 0,
    label: "Toate",
  },
  { value: 1, label: "Rute locale" },
  { value: 2, label: "Rute internod" },
];

export const transportHistoryTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "Nr. auto",
    value: "masina",
    withSearch: true,
    minW: 125,
  },
  {
    label: "Sofer",
    value: "sofer",
    withSearch: true,
    minW: 125,
  },
  {
    label: "Ruta",
    value: "ruta",
    minW: 125,
    withFilter: routesTypes,
  },
  {
    label: "Ruta internod",
    value: "ruta_intranod",
    minW: 125,
  },
  {
    label: "Data start",
    value: "data_start",
    minW: 125,
  },
  {
    label: "Data stop",
    value: "data_stop",
    minW: 125,
  },
];

export const getTransportHistoryTableData = (
  data: ActiveTransportsDataInterface[],
): TableData[] =>
  data.map((item) => {
    return {
      id: item.id_transport,
      crudData: item,
      data: [
        {
          title: item.masina,
        },
        {
          title: item.sofer,
        },
        {
          title: item.ruta ?? "-",
        },
        {
          title: item.ruta_intranod ?? "-",
        },
        {
          title: getDateAndTime(item.data_start) ?? "-",
        },
        {
          title: getDateAndTime(item.data_stop) ?? "-",
        },
      ],
    };
  });
